module.exports = __webpack_public_path__ + "img/711.70df5e3c.png";